import { Col, Pagination, Row, Space } from 'antd'
import React from 'react'
import JobCard from './JobCard'
import { Content } from 'antd/lib/layout/layout'

const ListingPage = ({roles, page, setPage, total}) => {

    const onChange = (page) => {
        setPage(page)
    }

  return (
    <Content style={{ paddingBlock:'20px'}}>
        <div style={{minHeight: '500px'}}>
            <Row gutter={20}>
                {
                    roles?.map((role, i) => (
                        <Col key={i} lg={8} sm={12} span={24}>
                            <JobCard role={role} />
                        </Col>
                    ))
                }
            </Row>
        </div>
        <Space style={{width: '100%', justifyContent: 'center', marginTop: '20px'}} align='center'>
            <Pagination current={page} total={total} onChange={onChange} defaultPageSize={9} />
        </Space>
    </Content>
  )
}

export default ListingPage